<template>
  <div id="app">
    <Header v-if="showHeader" :routeName="routeName" />
    <router-view />
    <Footer v-if="showFooter" />
    <el-backtop />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      routeName: "0",
      showHeader: true,
      showFooter: true,
    };
  },
  mounted() {
    this.getRouteName();
  },
  watch: {
    "$route.name"() {
      this.getRouteName();
    },
  },
  methods: {
    getRouteName() {
      const name = this.$route.name;
      if (name === "Home") {
        this.routeName = "0";
      } else if (name === "DownManage") {
        this.routeName = "2";
      } else if (name === "AnnouncementCenter") {
        this.routeName = "2";
      } else if (name === "Help") {
        this.routeName = "2";
      } else {
        this.routeName = "1";
      }
      if (name === "Login") {
        this.showHeader = false;
        this.showFooter = false;
      } else {
        this.showHeader = true;
        this.showFooter = true;
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  max-width: 1920px;
  text-align: center;
  min-width: 1320px;
  margin: 0 auto;
}
html,
body {
  font-family: "Microsoft YaHei";
  height: 100%;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue